var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.1 78.2",
    style: {
      enableBackground: "new 0 0 76.1 78.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#97d3c5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.2,48.1c0,0-0.1,0-0.1,0c-8.1,0.1-14.8,6.7-14.9,14.8c-0.1,4,1.4,7.8,4.2,10.7c0.2,0.2,0.4,0.4,0.7,0.7 H10.2L9,73.9c-3-0.9-5-3.6-5-6.8c0-18.7,0-37.4,0-56.1c0-3.8,3.1-7,7-7C18.5,3.9,26.2,4,33.6,4L38,4c0.1,0,0.2,0.1,0.3,0.1 c0.2,0.2,0.4,0.4,0.7,0.6c-0.1,1.7-0.1,5.5-0.1,5.5c0,0.7,0,1.3,0,2c0,1.7,0,3.4,0.1,5.2c0,3.3,2.4,6.1,5.8,6.7 c2.3,0.3,7.6,0.2,11.4,0.1c0.8,0,1.5,0,2.2,0c0.2,0.2,0.4,0.4,0.6,0.6c0.2,0.2,0.3,0.6,0.3,0.9c0,5.6,0,7.6,0,11.4l0,4.6 c0,1.1,0.9,2,2,2s2-0.9,2-2l0-4.6c0-3.8,0-5.8,0-11.4c0-1.3-0.4-2.5-1.2-3.5c0-0.1-0.1-0.1-0.1-0.2c-0.3-0.3-0.6-0.6-0.9-0.9 c-0.1-0.2-0.2-0.3-0.3-0.4c-1.2-1.2-2.7-2.7-4.5-4.4c-5-5-10-10-15.1-15.1c-0.8-0.7-1.7-1.2-2.8-1.2c0,0-0.1,0-0.1,0l-4.5,0 c-7.4,0-15.1-0.1-22.7,0C4.9,0.1,0,5,0,11c0,18.7,0,37.4,0,56.1c0,4.9,3.1,9.1,7.8,10.6l1.6,0.5c0.2,0.1,0.4,0.1,0.6,0.1h51.1 c0.1,0,0.3,0,0.4,0c8.1-0.2,14.5-6.7,14.6-14.8c0,0,0,0,0,0C76.2,55.1,69.6,48.2,61.2,48.1z M42.8,10.2c0-0.1,0-0.7,0-1.3 c1.8,1.8,4,3.9,6,5.9c1.5,1.5,3.1,3,4.5,4.4c0.4,0.4,0.7,0.8,1.1,1.1c-3.4,0-7.5,0.1-9.2-0.1c-1.4-0.2-2.4-1.4-2.4-2.8 c0,0,0-0.1,0-0.1c-0.1-1.6-0.1-3.3-0.1-5C42.8,11.6,42.8,10.9,42.8,10.2z M61.2,74.2l-0.2,0c-6.1-0.1-11-5.1-10.9-11.2 c0.1-6,5-10.9,11-10.9c6,0,11,5.8,11,11.2C72.1,69.4,67.2,74.2,61.2,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.6,56.5c-0.4-0.4-0.9-0.6-1.4-0.6c0,0,0,0,0,0c-0.6,0-1.2,0.3-1.5,0.8l-5.9,5.9c-0.8,0.8-0.8,2,0,2.8 c0.4,0.4,0.9,0.6,1.4,0.6c0.5,0,1-0.2,1.4-0.6l2.7-2.7v5.7c0,1.1,0.9,2,2,2s2-0.9,2-2v-5.7l2.7,2.7c0.8,0.8,2,0.8,2.8,0 c0.8-0.8,0.8-2,0-2.8L62.6,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,38.3h12.9c1.1,0,2-0.9,2-2s-0.9-2-2-2H16.9c-1.1,0-2,0.9-2,2S15.8,38.3,16.9,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,42.6H16.9c-1.1,0-2,0.9-2,2s0.9,2,2,2h22.9c1.1,0,2-0.9,2-2S40.8,42.6,39.8,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,50.8H16.9c-1.1,0-2,0.9-2,2s0.9,2,2,2h22.9c1.1,0,2-0.9,2-2S40.8,50.8,39.8,50.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.990eab2c.svg";
export { ForwardRef as ReactComponent };